export const COLUMNS = {
  EXPAND: 'expand',
  TEAM_NAME: 'teamName',
  TEAM_ID: 'teamId',
  INTEGRATION_ID: 'integrationId',
  HEALTH: 'health',
  SUMMARY: 'summary',
} as const;

export const columns = [
  { id: COLUMNS.EXPAND, label: '', sortDisabled: true },
  { id: COLUMNS.TEAM_NAME, label: 'Team', sortDisabled: true },
  { id: COLUMNS.TEAM_ID, label: 'Team ID', sortDisabled: true },
  { id: COLUMNS.INTEGRATION_ID, label: 'Integration ID', sortDisabled: true },
  { id: COLUMNS.HEALTH, label: 'Health', sortDisabled: true },
  { id: COLUMNS.SUMMARY, label: 'Summary', sortDisabled: true },
];
